import { Anchor, Group, Tooltip } from '@mantine/core'
import { faUserPlus } from '@fortawesome/sharp-duotone-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export function RequestNewParticipantLink() {
  const url = import.meta.env.VITE_PARTICIPANT_REQUEST_FORM_URL as string | undefined
  const disabled = !url
  const handleClick = () => {
    if (url) globalThis.open(url, '_blank', 'noopener,noreferrer')
  }
  return (
    <Tooltip label={disabled ? 'Participant request form URL not configured' : 'Open participant request form'} withArrow>
      <Anchor
        component="button"
        type="button"
        fz="xs"
        c={disabled ? 'dimmed' : 'brand.7'}
        onClick={handleClick}
        aria-disabled={disabled}
        style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
      >
        <Group gap={4} wrap="nowrap">
          <FontAwesomeIcon icon={faUserPlus} size="xs" />
          Request New Participant
        </Group>
      </Anchor>
    </Tooltip>
  )
}
